import { Datacenter } from '@datadog/browser-core';
import { HandlerType, StatusType, datadogLogs } from '@datadog/browser-logs';

import { Loggable } from '@rbi-ctg/frontend';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

import {
  DataDog,
  RBIEnv,
  appVersionCode,
  brand,
  checkRbiEnv,
  env,
  isLocalDev,
  platform,
} from '../environment';

export { StatusType } from '@datadog/browser-logs';

interface Context {
  [x: string]: Loggable | Loggable[];
}

interface DataDogLogger {
  context?: Context;
  message: string | Error;
  status: StatusType;
}

export function init(sampleRate?: number): void {
  let handler = HandlerType.http;

  if (checkRbiEnv(RBIEnv.TEST)) {
    handler = HandlerType.silent;
  }

  const defaultRate = isLocalDev ? 100 : 1;

  datadogLogs.init({
    clientToken: DataDog.logs.ClientToken || '',
    datacenter: Datacenter.US,
    forwardErrorsToLogs: true,
    env: env(),
    service: `${brand()}_${platform()}`,
    version: appVersionCode(),
    sampleRate: typeof sampleRate === 'number' ? sampleRate : defaultRate,
  });

  datadogLogs.logger.setHandler(handler);
}

const UNKNOWN_ERROR_MESSAGE: string = 'Unknown application error. Unable to parse error message.';

export function dataDogLogger({ message, context = {}, status }: DataDogLogger): void {
  const ctx = {
    appVersionCode: appVersionCode(),
    brand: brand(),
    platform: platform(),
    stage: env(),
    userId: LocalStorage?.getItem(StorageKeys.USER)?.cognitoId,
    ...context,
  };

  const strMessage: string =
    typeof message === 'string' ? message : message?.message || UNKNOWN_ERROR_MESSAGE;

  datadogLogs.logger.log(strMessage, ctx, status);
}

export function addContext(key: string, value: string) {
  datadogLogs.logger.addContext(key, value);
}
